"use client"
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

import { Link, Outlet } from "react-router-dom"
import { ArrowLeft } from "lucide-react"
import { LanguageToggle } from "@/components/layout/LanguageToggle"
import { useI18n } from "@/i18n"

/**
 * The stripped frame for the ONE screen that stays reachable without the health/AI consent: Privacy & data
 * (export, deletion, withdrawal). Chosen over the normal shell on purpose: the shell carries the Amy launcher
 * and drawer and the links into Today, Plan, Kitchen and Shop, and none of those may be reachable until the
 * consent is on record. What remains is a way back — to the consent screen (any gated route renders it, and
 * an unfinished onboarding redirects to its own consent interstitial) — and the language toggle.
 */
export function ConsentExemptFrame() {
  const { t } = useI18n()
  return (
    <div className="relative min-h-screen bg-cream text-ink">
      <header className="mx-auto flex w-full max-w-2xl items-center justify-between gap-4 px-4 pt-6">
        <Link
          to="/app/today"
          className="inline-flex min-h-11 items-center gap-2 text-sm font-semibold text-ink-2 underline-offset-2 hover:text-ink hover:underline"
        >
          <ArrowLeft className="size-4" aria-hidden="true" />
          {t("healthConsent.backToConsent")}
        </Link>
        <LanguageToggle />
      </header>
      <main id="main-content" className="mx-auto w-full max-w-2xl px-4 pt-4 pb-10">
        <Outlet />
      </main>
    </div>
  )
}
